import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  role,
  content,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white p-6 rounded-lg shadow-md border border-[#E5E7EB] relative" data-id="element-16">
      <Quote className="absolute top-4 right-4 text-[#D97706]/20 w-8 h-8" data-id="element-17" />
      <p className="text-gray-700 italic mb-6 relative z-10 font-serif" data-id="element-18">
        "{content}"
      </p>
      <div className="flex items-center" data-id="element-19">
        <div className="w-10 h-10 rounded-full bg-[#2C5F2D] flex items-center justify-center text-white font-bold text-lg mr-3" data-id="element-20">
          {name.charAt(0)}
        </div>
        <div data-id="element-21">
          <h4 className="font-bold text-gray-900 text-sm" data-id="element-22">{name}</h4>
          <p className="text-xs text-gray-500" data-id="element-23">{role}</p>
        </div>
      </div>
    </motion.div>;
}